import React, { useState, useEffect, useMemo } from 'react';
import customHeaders, { getSpace } from '../../../common/headers';
import { TitlePage } from '../../../components/TitlePage/TitlePage';
import { ButtonBasic, InputDinamycPlaceholder, DropDownSelector } from "@lk-gtcom/ecomlab-components";
import useGeneralStore from '../../../store/general';
import { DynamicFormComponent } from '../../../components/DynamicFormComponent/DynamicFormComponent';
import { ModalAddElementsDict } from './ModalAddElementsDict/ModalAddElementsDict';
import { ModalComponent } from '../../../components/Modal/ModalComponent/ModalComponent';
import './ModalCreateCalendarFields.scss';


interface ModalCreateCalendarFieldsProps {
    setIsModal: (isModal: boolean) => void
}

const TYPE_LIST = [
    { label: 'Строка', value: 'string' },
    { label: 'Чекбокс', value: 'bool' },
    { label: 'Число', value: 'int' },
    { label: 'Дробное число', value: 'float' },
    { label: 'Список с выбором значений', value: 'dict' },
    { label: 'Проценты', value: 'percent' },
    { label: 'Теги', value: 'array' },
    { label: 'Поле ввода для текста', value: 'field' },
]

const ModalCreateCalendarFields = ({
    setIsModal
}: ModalCreateCalendarFieldsProps) => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };

    // Поля 
    const [selectedType, setSelectedType] = useState(TYPE_LIST[0])
    const [fieldsdName, setFieldsName] = useState('')
    const [fields, setFilds] = useState([])
    const [fieldsArr, setFieldsArr] = useState([])
    const [fieldsList, setFieldsList] = useState([])
    const [listDict, setListDict] = useState([])

    // Модалка
    const [isModalAddElementsDict, setIsModalAddElementsDict] = useState(false)

    // Добавление полей
    const addFields = (fieldsdName) => {
        fetchAddAdditionalFieldsProject(fieldsdName)
        setFieldsName('');
    };

    // Получение полей
    const fetchGetAdditionalFields = (
        abortController = new AbortController()
    ) => {
        let url = `https://apps0.ecomru.ru:4553/api/v1/space_custom_attribute/list`

        fetch(url, {
            method: 'GET',
            headers,
            signal: abortController.signal,
        })
            .then((res) => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error('bad events response');
                }
            })
            .then((json) => {
                setFieldsArr(json);
                setFilds(json?.map(({ name, id, type, possible_values }) => ({ front_name: name, data_type: type, id: id, possible_values: possible_values || [] })))
            })
            .catch((err) => {
                console.error(err);
            });
        // .finally(() => {
        //     setLoad(false)
        // })

    };

    // Добавление доп полей к проекту
    const fetchAddAdditionalFieldsProject = (name: string) => {
        let url = `https://apps0.ecomru.ru:4553/api/v1/space_custom_attribute`

        const body = JSON.stringify({
            name: name,
            type: selectedType?.value,
            possible_values: listDict
        });

        fetch(url, { method: 'POST', headers, body })
            .then(res => {
                if (!res?.ok) { throw new Error('bad response') }
                return res.json()
            })
            .then(json => {
                setTimeout(() => fetchGetAdditionalFields(), 500)
            })
            .catch((err) => console.error(err));
    };

    // Изменение доп полей к проекту
    const fetchChangeAdditionalFieldsProject = (name: string, id: number | string, type: string, before: null | number | string = null, possible_values: [] | undefined) => {
        let url = `https://apps0.ecomru.ru:4553/api/v1/space_custom_attribute/${id}`

        const body = JSON.stringify({
            name: name,
            type: type,
            possible_values
        });

        fetch(url, { method: 'PATCH', headers, body })
            .then(res => {
                if (!res?.ok) { throw new Error('bad response') }
                return res.json()
            })
            .then(json => {
                setTimeout(() => fetchGetAdditionalFields(), 500)
            })
            .catch((err) => console.error(err));
    };

    // Удаление поля
    const fetchDeleteAdditionalFieldsProject = (id: number | string) => {
        let url = `https://apps0.ecomru.ru:4553/api/v1/space_custom_attribute/${id}`

        fetch(url, { method: 'DELETE', headers })
            .then(res => {
                if (!res?.ok) { throw new Error('bad response') }
                return res.json()
            })
            .then(json => {
                setTimeout(() => fetchGetAdditionalFields(), 500)
            })
            .catch((err) => console.error(err));
    };

    useEffect(() => {
        fetchGetAdditionalFields();
    }, []);

    const handleInput = (e, index) => {
        const curr = fields.map(({ name, field_type, id, possible_values }, ind) => {
            if (ind === index) {
                return { name: e, field_type: field_type, id: id, possible_values: possible_values || [] };
            } else {
                return { name: name, field_type: field_type, id: id, possible_values: possible_values || [] };
            }
        });
        setFilds(curr);
    };

    useMemo(() => {
        setFieldsList([
            ...fields.map(({ name, type, id, possible_values, before }, ind) => {
                return (
                    <div className="modal-add-project__fields-item">
                        <InputDinamycPlaceholder
                            changeValue={name}
                            onChange={(e) => handleInput(e ? e : name, ind)}
                            //  placeholder={name}
                            size="s"
                            onBlur={() => {
                                fetchChangeAdditionalFieldsProject(name, id, type, before, possible_values)
                            }}
                        />
                        <ButtonBasic
                            onClick={() => {
                                fetchDeleteAdditionalFieldsProject(id)
                            }}
                            red
                            text="Удалить"
                        />
                    </div>
                );
            }),
        ]);
    }, [fields]);


    return (
        <>
            {isModalAddElementsDict &&
                <ModalAddElementsDict
                    list={listDict}
                    setList={setListDict}
                    setIsModal={setIsModalAddElementsDict}
                />}

            <ModalComponent
                title={'Добавление полей'}
                onClose={() => setIsModal(false)}
                style={{
                    maxWidth: '1000px',
                    minHeight: '600px',
                    height: 'auto'
                }}
                child={
                    <div className="modal-add-fields-crm">
                        <div className="modal-add-fields-crm__request-list">
                            <div className='modal-add-fields-crm__fields'>
                                <div className="modal-add-fields-crm__fields-row">
                                    <InputDinamycPlaceholder
                                        changeValue={fieldsdName}
                                        onChange={(e) => setFieldsName(e)}
                                        placeholder="Введите название поля"
                                        size="s"
                                    />

                                    <DropDownSelector
                                        options_prop={TYPE_LIST}
                                        state={selectedType}
                                        setState={(e) => setSelectedType(e)}
                                        placeholder="Тип поля"
                                        isClearable={false}
                                    />

                                    <ButtonBasic
                                        minWidth='210px'
                                        blue
                                        disabled={selectedType?.value !== 'dict'}
                                        text='Настроить список'
                                        onClick={(e) => {
                                            setIsModalAddElementsDict(true)
                                        }}
                                    />

                                    <ButtonBasic
                                        green
                                        width='auto'
                                        text="Создать"
                                        onClick={() => {
                                            if (fieldsdName?.length > 0) {
                                                addFields(fieldsdName);
                                            }
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="modal-add-fields-crm__fields-group">
                                <TitlePage
                                    medium
                                    title={'Готовые поля'}
                                />

                                <div className="modal-add-fields-crm__fields-content">
                                    <DynamicFormComponent
                                        productTemporary={fields}
                                        fetchDelete={fetchDeleteAdditionalFieldsProject as any}
                                        fetchChange={fetchChangeAdditionalFieldsProject as any}
                                        isEdit={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                }
            />
        </>
    );
};

export { ModalCreateCalendarFields };